export default "__VITE_ASSET__BCNxLPEJ__"